// used for ajax calls to server
export const GET_USER_ROLES = 'GET_USER_ROLES';
export const GET_USER_ROLES_SUCCESS = 'GET_USER_ROLES_SUCCESS';
export const GET_USER_ROLES_ERROR = 'GET_USER_ROLES_ERROR';

export const SAVE_USER_ROLE = 'SAVE_USER_ROLE';
export const SAVE_USER_ROLE_SUCCESS = 'SAVE_USER_ROLE_SUCCESS';
export const SAVE_USER_ROLE_ERROR = 'SAVE_USER_ROLE_ERROR';

// used for local state changes
// export const ADD_GROUP_TO_ROLE = 'ADD_GROUP_TO_ROLE';
// export const REMOVE_GROUP_FROM_ROLE = 'REMOVE_GROUP_FROM_ROLE';
// export const DISCARD_ROLE_CHANGES = 'DISCARD_ROLE_CHANGES';


